module.exports = __webpack_public_path__ + "img/arcade-bg.321207ad.png";